var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',_vm._g(_vm._b({attrs:{"items":_vm.topics,"menu-props":{ maxHeight: '400' },"item-text":'name',"item-value":_vm.$attrs['return-object'] === undefined ? 'id' : undefined,"label":_vm.$tc('choose_topic'),"hint":_vm.$tc('choose_topic'),"attach":""}},'v-select',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }